import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import PracticePageContent from "../_PracticePageContent";

import { useLazyGetEnvelopeThemePracticeAssignmentsQuery, useGetUserThemeByIdQuery } from "api/generated";

import type { UserAssignmentPracticeFragment } from "api/generated";

import { translateEnvelopeId } from "utils/translateEnvelopeId";
import { processApiError } from "utils/processApiError";

const EnvelopeSuperTopicPractice = () => {
  const { envelopeId, themeId } = useParams();
  if (envelopeId === undefined || themeId === undefined) return null;

  const topicId = `${themeId}-${envelopeId}`;

  const {
    data: themeData,
    isLoading: isThemeLoading,
    error: apiThemeError,
  } = useGetUserThemeByIdQuery({ userThemeId: themeId });

  const [trigger, { data: assignmentsData, isLoading: isAssignmentsLoading, error: lazyAssignmentsError }] =
    useLazyGetEnvelopeThemePracticeAssignmentsQuery();

  const [allAssignments, setAllAssignments] = useState<UserAssignmentPracticeFragment[] | null>(null);

  useEffect(() => {
    if (apiThemeError === undefined) return;

    processApiError(apiThemeError);
  }, [apiThemeError]);

  useEffect(() => {
    if (lazyAssignmentsError === undefined) return;

    processApiError(lazyAssignmentsError);
  }, [lazyAssignmentsError]);

  useEffect(() => {
    const themeId = themeData?.userTheme.theme?.id;
    if (!themeId) return;

    trigger({ themeId, envelopeId: translateEnvelopeId(envelopeId) }).catch(() => {});
  }, [themeData]);

  useEffect(() => {
    if (assignmentsData === undefined) return;

    const assignments = assignmentsData.userAssignmentsCached.items.filter(
      assignment => assignment.assignment?.isActive,
    );
    setAllAssignments(assignments);
  }, [assignmentsData]);

  return (
    <PracticePageContent
      isLoading={isThemeLoading || isAssignmentsLoading}
      assignments={allAssignments}
      title={themeData?.userTheme.theme?.appName ?? themeData?.userTheme.theme?.name ?? ""}
      topicId={topicId}
    />
  );
};

export default EnvelopeSuperTopicPractice;
